<div class="container justify-content-center">
    <img src="/assets/Assets/ARTEMIS-NEW.png" class="img-fluid" alt="ARTEMIS">
</div>